import * as React from "react";

import { WithTranslation, withTranslation } from "react-i18next";
import CardList from "~/components/CustomerSupport/CardList";
import { shopConfig } from "~/helpers/shopConfig";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";
import { StyledCard as Card } from "~/layouts/StyledCard";
import SupportDashboardLayout from "~/layouts/SupportDashboardLayout";

class B2BIndex extends React.Component<WithTranslation> {
  public render() {
    const { t } = this.props;
    return (
      <SupportDashboardLayout>
        <CardList>
          <Card>
            <p
              dangerouslySetInnerHTML={{
                __html: t("description", {
                  b2bEmailAddress: shopConfig.b2bEmailAddress
                })
              }}
            />
          </Card>

          <Callout intent="warning" title={t("warning.title")}>
            <div>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("warning.description")
                }}
              />
            </div>
          </Callout>
        </CardList>
      </SupportDashboardLayout>
    );
  }
}

export default withTranslation("b2b")(B2BIndex);



// WEBPACK FOOTER //
// ./src/pages/B2B/B2BIndex.tsx